var exhibitorList = (($, undefined) => {
	const init = () => {};

	return { init };

})(jQuery);


// $(() => {
// 	exhibitorList.init();
// });

export {exhibitorList as default}